import { render, staticRenderFns } from "./IbTextField.vue?vue&type=template&id=4ab1336d"
var script = {}
import style0 from "./IbTextField.vue?vue&type=style&index=0&id=4ab1336d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports